/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccelerationChannelOrientationConfiguration } from './accelerationChannelOrientationConfiguration';
import { ActivityChannelOrientationConfiguration } from './activityChannelOrientationConfiguration';
import { CameraFormat } from './cameraFormat';


export interface DeviceTypeAddDto { 
    accelerationChannelOrientations?: AccelerationChannelOrientationConfiguration;
    activityChannelOrientations?: ActivityChannelOrientationConfiguration;
    articleNumbers?: Array<Array<string>>;
    cameraFormats?: Array<CameraFormat>;
    comType: DeviceTypeAddDto.ComTypeEnum;
    configurationOptions?: Array<DeviceTypeAddDto.ConfigurationOptionsEnum>;
    customerName: string;
    deviceClassId: string;
    deviceClassWithOwnIdPool: DeviceTypeAddDto.DeviceClassWithOwnIdPoolEnum;
    identifier: number;
    isLifetimeCalculationAvailable?: boolean;
    maxCameraId?: number;
    minCameraId?: number;
    name: string;
}
export namespace DeviceTypeAddDto {
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
    export const ConfigurationOptionsEnum = {
        Usb: 'USB',
        Bluetooth: 'BLUETOOTH',
        Uhf: 'UHF',
        Uart: 'UART'
    } as const;
    export type ConfigurationOptionsEnum = typeof ConfigurationOptionsEnum[keyof typeof ConfigurationOptionsEnum];
    export const DeviceClassWithOwnIdPoolEnum = {
        Collar: 'COLLAR',
        ExternalSensor: 'EXTERNAL_SENSOR',
        Camera: 'CAMERA',
        Tt4Sensor: 'TT4_SENSOR',
        ConfigurationDevice: 'CONFIGURATION_DEVICE',
        DropOff: 'DROP_OFF',
        TrapTransmitter: 'TRAP_TRANSMITTER',
        DataLogger: 'DATA_LOGGER'
    } as const;
    export type DeviceClassWithOwnIdPoolEnum = typeof DeviceClassWithOwnIdPoolEnum[keyof typeof DeviceClassWithOwnIdPoolEnum];
}


export type ConfigurationOptionsEnum = typeof DeviceTypeAddDto.ConfigurationOptionsEnum[keyof typeof DeviceTypeAddDto.ConfigurationOptionsEnum];
